import {GridLocaleText} from '@mui/x-data-grid-pro';
import {LabelDisplayedRowsArgs} from '@mui/material';

export const GRID_LOCALE_TEXT: Partial<GridLocaleText> = {
  // Root
  noRowsLabel: 'Ingen rader',
  noResultsOverlayLabel: 'Søket ga ingen treff',
  errorOverlayDefaultLabel: 'En feil oppstod.',

  // Density selector toolbar button text
  toolbarDensity: 'Density',
  toolbarDensityLabel: 'Density',
  toolbarDensityCompact: 'Compact',
  toolbarDensityStandard: 'Standard',
  toolbarDensityComfortable: 'Comfortable',

  // Columns selector toolbar button text
  toolbarColumns: 'Columns',
  toolbarColumnsLabel: 'Select columns',
  

  // Filters toolbar button text
  toolbarFilters: 'Filters',
  toolbarFiltersLabel: 'Show filters',
  toolbarFiltersTooltipHide: 'Hide filters',
  toolbarFiltersTooltipShow: 'Show filters',
  toolbarFiltersTooltipActive: count =>
    count !== 1 ? `${count} active filters` : `${count} active filter`,

  // Export selector toolbar button text
  toolbarExport: 'Export',
  toolbarExportLabel: 'Export',
  toolbarExportCSV: 'Download as CSV',
  toolbarExportPrint: 'Export Print',
  actionsCellMore: 'more',
  // Columns panel text
  columnsPanelTextFieldLabel: 'Find column',
  columnsPanelTextFieldPlaceholder: 'Column title',
  columnsPanelDragIconLabel: 'Reorder column',
  columnsPanelShowAllButton: 'Show all',
  columnsPanelHideAllButton: 'Hide all',

  // Filter panel text
  filterPanelAddFilter: 'Add filter',
  filterPanelDeleteIconLabel: 'Delete',
  filterPanelOperators: 'Operators',
  filterPanelOperatorAnd: 'And',
  filterPanelOperatorOr: 'Or',
  filterPanelColumns: 'Columns',
  filterPanelInputLabel: 'Value',
  filterPanelInputPlaceholder: 'Filter value',

  // Filter operators text
  filterOperatorContains: 'contains',
  filterOperatorEquals: 'equals',
  filterOperatorStartsWith: 'starts with',
  filterOperatorEndsWith: 'ends with',
  filterOperatorIs: 'is',
  filterOperatorNot: 'is not',
  filterOperatorAfter: 'is after',
  filterOperatorOnOrAfter: 'is on or after',
  filterOperatorBefore: 'is before',
  filterOperatorOnOrBefore: 'is on or before',
  filterOperatorIsEmpty: 'is empty',
  filterOperatorIsNotEmpty: 'is not empty',

  // Filter values text
  filterValueAny: 'noen',
  filterValueTrue: 'ekte',
  filterValueFalse: 'falsk',

  // Column menu text
  columnMenuLabel: 'Meny',
  columnMenuShowColumns: 'Vis kolonner',
  columnMenuFilter: 'Filter',
  columnMenuHideColumn: 'Gjemme seg',
  columnMenuUnsort: 'Usortert',
  columnMenuSortAsc: 'Sorter stigende',
  columnMenuSortDesc: 'Sorter synkende',

  // Column header text
  columnHeaderFiltersTooltipActive: count =>
    count !== 1 ? `${count} aktive filtre` : `${count} aktive filter`,
  columnHeaderFiltersLabel: 'Vis filtre',
  columnHeaderSortIconLabel: '',

  // Rows selected footer text
  footerRowSelected: count =>
    count !== 1
      ? `${count.toLocaleString()} valgte`
      : `${count.toLocaleString()} valgt`,

  // Total rows footer text
  footerTotalRows: 'Totalt:',

  // Total visible rows footer text
  footerTotalVisibleRows: (visibleCount, totalCount) =>
    `${visibleCount.toLocaleString()} av ${totalCount.toLocaleString()}`,

  // Checkbox selection text
  checkboxSelectionHeaderName: 'Avmerkingsboks',

  // Boolean cell text
  booleanCellTrueLabel: 'ekte',
  booleanCellFalseLabel: 'falsk',

  // Used core components translation keys
  MuiTablePagination: {
    labelRowsPerPage: 'Treff per side:',
    getItemAriaLabel: (type) => {
        if (type === 'next') {
          return 'Neste side';
        }
        if (type === 'previous') {
        return 'Forrige side';
      }
      return '';
    },
    labelDisplayedRows: ({ from, to, count }: LabelDisplayedRowsArgs) =>
      `${from}-${to} av ${count !== -1 ? count : `mer enn ${to}`}`,
    
  },
};
